<template>
    <div class="login_content" :style="{backgroundImage: 'url(' + bgimg + ')'}">
        <div class="login_box">
            <div class="login_clear clear">
                <div class="login_swiper_content">
                    <swiper class="login_swiper_box" :options="swiperOption">
                        <swiper-slide v-for="(item, index) in advlist" :key="index"><img :src="item" /></swiper-slide>
                        <div class="login_swiper_pagination" slot="pagination"></div>
                    </swiper>
                </div>
                <div class="login_main">
                    <div class="login_logo"><img :src="logoimg" alt="logo" /></div>
                    <div class="login_title clear">
                        <h3>登录</h3>
                        <router-link :to="{name: 'Register'}" v-if="isselfreg == 1">注册新账号</router-link>
                    </div>
                    <div class="login_form">
                        <Form ref="formLogo" :model="logoValidate" :rules="logoRule">
                            <FormItem prop="name" :show-message="false">
                                <Input type="text" placeholder="帐号" :maxlength="11" v-model="logoValidate.name" />
                            </FormItem>
                            <FormItem prop="password" :show-message="false">
                                <Input type="password" placeholder="密码" v-model="logoValidate.password" />
                            </FormItem>
                            <div class="login_link ivu-form-item clear">
                                <!-- <router-link to="/" class="login_link_left">游客模式</router-link> -->
                                <router-link :to="{name: 'Findpassword'}" class="login_link_right">忘记密码？</router-link>
                            </div>
                            <FormItem>
                                <Button class="login_btn" type="warning" long  @click="handleSubmit('formLogo')">登录</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <div class="login_qrcode_content">
                        <div class="login_qrcode_box">
                            <img :src="qrcodel" />
                            <span>APP下载</span>
                        </div>
                        <div class="login_qrcode_box">
                            <img :src="qrcoder" />
                            <span>小程序端订货</span>
                        </div>
                    </div>
                </div>
                <div class="login_copyright_content"><span>{{tcpip}}</span></div>
            </div>
        </div>
        <!-- 漂浮客服 -->
        <ServerFixed></ServerFixed>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import qs from 'Qs'
import ServerFixed from '@/components/component/serverfixed.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    components: {ServerFixed, swiper, swiperSlide},
    data() {
        return {
            logoimg: '', // logo
            bgimg: '', // 背景图
            tcpip: '', // 备案信息
            advlist: [], // 轮播图
            isselfreg: 0, // 是否可以注册 0 不允许 1 允许
            swiperOption: { // 轮播图设置选项
                autoplay: { // 自动滚动
                    disableOnInteraction: false
                },
                pagination: { // 分页器
                    el: '.login_swiper_pagination',
                    clickable :true,
                }
            },
            logoValidate: { // 表单内容
                name: '', // 帐号
                password: '', // 密码
            },
            logoRule: { // 表单验证
                name: [
                    {required: true, trigger: 'blur'}
                ],
                password: [
                    {required: true, trigger: 'blur'}
                ],
            },
            qrcodel: '',
            qrcoder: ''
        }
    },
    methods: {
        getInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.logininfo + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    this.logoimg = response.data.msg.baseinfo.orderinglogo
                    this.bgimg = response.data.msg.backgroundlist[0]
                    this.tcpip = response.data.msg.tcpip
                    this.advlist = response.data.msg.advlist
                    this.qrcodel = response.data.msg.qrcodelist[0]
                    this.qrcoder = response.data.msg.qrcodelist[1]
                    this.isselfreg = response.data.msg.baseinfo.is_selfreg
                    response.data.msg.baseinfo.is_openshop ? this.$store.state.openmall = true : this.$store.state.openmall = false
                    if (response.data.msg.baseinfo.is_openshop == 1 && this.$store.state.requireAuth == false) {
                        this.$router.push('/')
                    }
                    
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = response.data.msg.baseinfo.managelogo;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        submitInfo () { // 提交数据
            let data = {
                i_account: this.logoValidate.name,
                i_password: this.logoValidate.password
            }
            axios({
                url: this.getWebsite() + api.login + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    if (!response.data.error) { // 登录成功
                        if (response.data.msg.customerinfo) {
                            document.cookie = "cook_ShopId=" + response.data.msg.customerinfo.shopid
                            document.cookie = "cook_cus_uid=" + response.data.msg.customerinfo.uid
                            document.cookie = "cook_cus_pwd=" + response.data.msg.customerinfo.password
                            // 登录成功后跳转到指定页面
                            if (response.data.msg.customerinfo.pass_status == 1) {
                                /**
                                 * Vuex在用户刷新的时候userLogin会回到默认值false，所以需要用到HTML5储存
                                 * 设置一个名为Flag，值为requireAuth的字段，作用是如果Flag有值且为requireAuth的时候，证明用户已经登录了
                                 */
                                localStorage.setItem("Flag", "requireAuth")
                                this.$store.dispatch('openmallFun', false)
                                // 友好提示
                                this.$Message.success('登录成功!')
                                this.$router.push("/")
                            } else {
                                this.$router.push({
                                    name: 'Result',
                                    params: {
                                        uid: response.data.msg.customerinfo.uid
                                    }
                                })
                            }
                        } else {
                            window.location.href= response.data.msg.siteurl + '/index.php?c=login&act=switchshop&client=weixin&username=' + response.data.msg.memberinfo.username + '&password=' + this.logoValidate.password
                        }
                    } else { // 登录失败
                        this.$Message.error(response.data.msg)
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        handleSubmit (name) { // 点击登录按钮
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                } else {
                    if (this.$refs[name].model.name == '' && this.$refs[name].model.password == '') {
                        this.$Message.error('帐号密码不能为空!');
                    } else if (this.$refs[name].model.name == '') {
                        this.$Message.error('帐号不能为空!');
                    } else if (this.$refs[name].model.password == '') {
                        this.$Message.error('密码不能为空!');
                    }
                }
            })
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.login_box {
    height: 580px;
    margin: -290px 0 0 -450px;
}

.login_clear {
    height: 100%;
    position: relative;
}

.login_swiper_content {
    width: 500px;
    height: 100%;
    float: left;
}

.login_swiper_box {
    width: 100%;
    height: 100%;
    position: relative;
}

.login_swiper_box img {
    width: 100%;
    min-height: 100%;
}

.login_swiper_pagination {
    text-align: center;
    position: absolute;
    z-index: 1;
}

.login_main {
    width: 400px;
    height: 100%;
    padding: 0 62px 0 56px;
    float: right;
}

.login_logo {
    padding-top: 34px;
    font-size: 0;
}

.login_logo img {
    max-width: 210px;
    height: 45px;
}

.login_title {
    padding-top: 34px;
}

.login_title h3 {
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    color: #333;
    float: left;
    font-weight: 500;
}

.login_title a {
    height: 14px;
    line-height: 14px;
    margin-top: 8px;
    font-size: 14px;
    color: #FF8000;
    float: right;
}

.login_form {
    padding-top: 20px;
}

.login_link {
    margin-top: -10px;
}

.login_link a {
    font-size: 14px;
    color: #999;
}

.login_link_left {
    float: left;
}

.login_link_right {
    float: right;
}

.login_btn.ivu-btn {
    height: 48px;
    font-size: 20px;
    color: #fff;
}

.login_qrcode_content {
    padding-top: 32px;
    margin: 0 -62px 0 -56px;
    text-align: center;
}

.login_qrcode_box {
    margin: 0 35px;
    font-size: 0;
    display: inline-block;
}

.login_qrcode_box img {
    width: 80px;
    height: 80px;
}

.login_qrcode_box span {
    margin-top: 20px;
    font-size: 14px;
    color: #333;
    display: block;
}







</style>


// WEBPACK FOOTER //
// src/components/views/login/login.vue